import { queryOptions } from '@tanstack/react-query'
import { AxiosInstance } from 'axios'
import { User, UserForEnvironment } from 'types/user'
import { DEFAULT_STALE_TIME_MS } from './queryDefaults'

export const GetUserByIdQueryOptions = (apiClient: AxiosInstance, userId: string) => {
  return queryOptions({
    queryKey: ['users', 'current', { userId }],
    queryFn: () => getUserById(apiClient, userId),
    staleTime: DEFAULT_STALE_TIME_MS,
  })
}

export const GetUsersQueryOptions = (apiClient: AxiosInstance, customerId: string) => {
  return queryOptions({
    queryKey: ['users', 'list', { customerId }],
    queryFn: () => getUsers(apiClient, customerId),
    staleTime: DEFAULT_STALE_TIME_MS,
  })
}

export const updateCurrentUser = async (apiClient: AxiosInstance, user: any) => {
  const { data } = await apiClient.put(`/users/${user.userId}`, user)
  return data
}

const getUserById = async (apiClient: AxiosInstance, userId: string): Promise<User> => {
  const { data } = await apiClient.get(`/users/${userId}`)
  return data
}

const getUsers = async (apiClient: AxiosInstance, customerId: string): Promise<User[]> => {
  const { data } = await apiClient.get(`/users/customers/${customerId}/workers`)
  return data
}

export const acceptLicense = async (apiClient: AxiosInstance) => {
  const { data } = await apiClient.get('/users/accept-license')
  return data
}

export const uploadAvatar = async (apiClient: AxiosInstance, avatar: any) => {
  const { data } = await apiClient.post('/users/upload-avatar', avatar, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return data
}

export const updateSettings = async (apiClient: AxiosInstance, setting: any) => {
  const { data } = await apiClient.patch('/users/settings', setting)
  return data
}

export const GetUserForEnvironmentQueryOptions = (apiClient: AxiosInstance, environmentId: string, userId: string) => {
  return queryOptions({
    queryKey: ['users', 'environment', { environmentId, userId }],
    queryFn: () => getUserForEnvironment(apiClient, environmentId, userId),
    staleTime: DEFAULT_STALE_TIME_MS,
  })
}

export const getUserForEnvironment = async (
  apiClient: AxiosInstance,
  environmentId: string,
  userId: string
): Promise<UserForEnvironment> => {
  const { data } = await apiClient.get(`/users/environment/${environmentId}/users/${userId}`)
  return data
}
